export const PENDING_CHECKIN_COLUMNS = [
  {
    fieldName: 'id',
    headerName: 'ROW_ACTIONS',
    size: 40,
  },
  {
    fieldName: 'vehicle_no',
    headerName: 'Vehicle No',
    size: 110,
  },
  {
    fieldName: 'checkout_no',
    headerName: 'Checkout No',
    size: 80,
  },
  {
    fieldName: 'dc_no',
    headerName: 'DC No',
    size: 100,
  },
  {
    fieldName: 'dc_date',
    headerName: 'DC Date',
    size: 90,
  },
  {
    fieldName: 'plant',
    headerName: 'Plant',
    size: 100,
  },
  {
    fieldName: 'customer_name',
    headerName: 'Customer',
    size: 140,
  },
  {
    fieldName: 'project_name',
    headerName: 'Project',
    size: 120,
  },
  {
    fieldName: 'grade',
    headerName: 'Grade',
    size: 80,
  },
  {
    fieldName: 'dc_quantity',
    headerName: 'Qty',
    size: 70,
  },
  {
    fieldName: 'driver_name',
    headerName: 'Driver',
    size: 100,
  },
];

export function mapPendingCheckInRow(checkout) {
  const dc = checkout?.delivery_challan || {};
  const ws = dc.work_schedule || {};
  const soDetail = ws.sales_order_detail || {};
  const so = soDetail.sales_order || {};
  const consignee = so.consignee || {};
  const customer = consignee.customer || {};
  const plant = ws.plant || {};
  const prefix = dc.prefix || '';
  const dcNo = dc.delivery_challan_no || '';

  return {
    id: checkout.id,
    checkout_no: checkout.checkout_no,
    dc_no: `${prefix}${dcNo}`,
    dc_date: dc.delivery_challan_date || '',
    dc_time: dc.delivery_challan_time || '',
    schedule_no: ws.schedule_no || '',
    sales_order_no: `${so.prefix || ''}${so.order_no || ''}`,
    plant: plant.alias_name || plant.name || '',
    plant_id: checkout.plant_id || plant.id || null,
    customer_name: customer.name || '',
    consignee_name: consignee.name || '',
    project_name: consignee.project_name || consignee.name || '',
    grade: soDetail.product?.name || '',
    dc_quantity: dc.dc_qty ?? '',
    vehicle_no: dc.vehicle?.name || dc.customer_vehicle_no || '',
    driver_name: dc.driver_name || checkout.driver_name || '',
    driver_mobile_no: dc.driver_mobile_no || '',
  };
}
